export default __webpack_public_path__ + "static/media/IMG_5544.0bfad17b.jpg";